import React from 'react';
import { ReactBingmaps } from 'react-bingmaps';
import { connect } from 'react-redux';
import './MapaVrp.css';
import BingKey from '../api/bing_key';

class MapaVrp extends React.Component {

    generateRoute(ruta){
        
        if (ruta.length>0){
            
            var rutaStr = "";

            rutaStr = rutaStr + (ruta[0]+1);

            for (var i = 1; i < ruta.length; i++){

                rutaStr = rutaStr + " -> " + (ruta[i]+1);
            }

            return rutaStr;
        }
        
        return "---";
    }
    
    generatePushPin(id,coordinate){
        
        const id_1 = id + 1
        const temp_loc ={};
        temp_loc['location'] = [coordinate['latitude'],coordinate['longitude']];
        temp_loc['option'] = {title: 'Locacion ' + id_1};
        
        return temp_loc
        
    }
  
    render(){
        
        if (this.props.route.length >0 ){
            
            const nodes = this.props.matrix[0].resources[0].origins;
            
            const pushPins= nodes.map((coord, index) => this.generatePushPin(index,coord))
            
            return (
                    <div>
                    <div className="row">
                        <h3>Ruta</h3>
                        <h4>{this.generateRoute(this.props.route)}</h4>
                    </div>
                    <div className = "container">
                        <ReactBingmaps
                          center = {[-2.1760, -79.9049]}
                          bingmapKey = {BingKey}
                          pushPins = { pushPins}
                        > </ReactBingmaps>
                    </div>
                    </div>
                    

            );
            
        }
        
        return (<div>
                <div className="ui message">
                    <div className="header">
                        Indicate locations in the city of Guayaquil in the following format:
                    </div> 
                    <code>latitude_1,longitude_1; latitude_2,longitude_2; ... ;latitude_n,longitude_n</code>
                    <h5>
                    For example:
                    </h5>
                    <code>
                    -2.1686,-79.9191;-2.1517,-79.8859;-2.1569,-79.9450;-2.161174, -79.937526;-2.145821, -79.904824
                    </code>
                </div >
                <div  className = "container">
                    <ReactBingmaps
                          center = {[-2.1760, -79.9049]}
                          bingmapKey = {BingKey}
                    > </ReactBingmaps>
                </div>
                </div>
               
               );
        
        
    }
    
}

const mapStateToProps = (state) => {
    return {matrix:state.matrix,
            route: state.route};
}

export default connect(mapStateToProps,)(MapaVrp);